import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SPARedirectHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if there's a stored path from the catch-all redirect
    const storedPath = sessionStorage.getItem('spa_redirect_path');
    
    if (storedPath) {
      // Clear the stored path
      sessionStorage.removeItem('spa_redirect_path');
      
      // Navigate to the stored path
      navigate(storedPath, { replace: true });
    }
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default SPARedirectHandler;
